/* ARF Mega-Menü 2.0 · Desktop (Hover mit Verzögerung + Sicherheitsdreieck) + Handy-Menü (Ebenen) · v1 */
(function () {
  'use strict';
  if (window.__arfMegaJs) return;
  window.__arfMegaJs = 1;

  var D = document, H = D.documentElement, W = window;
  var desk = W.matchMedia('(min-width: 990px)');
  var M = null, PN = null, N = null;
  var triggers = [], cur = null, isOpen = false, openY = 0;
  var tOpen = 0, tClose = 0, tSwitch = 0, pts = [], lastPointer = 'mouse';
  var CHEV = '<span class="amn-chev" aria-hidden="true"></span>';
  var ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  var XI = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function petFromPath() { return /katz|cat/i.test(location.pathname) ? 'katze' : 'hund'; }
  function loadImgs(root) {
    if (!root || root.__imgs) return;
    root.__imgs = 1;
    var l = root.querySelectorAll('img[data-src]');
    for (var i = 0; i < l.length; i++) { l[i].src = l[i].getAttribute('data-src'); l[i].removeAttribute('data-src'); }
  }
  function copyCode(btn) {
    var code = btn.getAttribute('data-code'), lab = btn.querySelector('[data-l]');
    function done() {
      btn.classList.add('is-copied'); if (lab) lab.textContent = 'Kopiert ✓';
      clearTimeout(btn.__t); btn.__t = setTimeout(function () { btn.classList.remove('is-copied'); if (lab) lab.textContent = 'Kopieren'; }, 1800);
    }
    try { navigator.clipboard.writeText(code).then(done, done); } catch (e) { done(); }
  }

  /* ================= Desktop ================= */
  function hdrBottom() {
    var hdr = D.querySelector('header.pets-header');
    if (!hdr) return 0;
    var b = 0, main = hdr.querySelector('.pets-main'), nav = D.querySelector('.pets-nav');
    if (main) b = main.getBoundingClientRect().bottom;
    if (nav) {
      var r = nav.getBoundingClientRect(), cs = getComputedStyle(nav);
      if (r.height > 8 && cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.5) b = Math.max(b, r.bottom);
    }
    return Math.max(0, Math.round(b));
  }
  function place() { if (M) M.style.setProperty('--am-top', hdrBottom() + 'px'); }
  function setView(p, animate) {
    if (!M) return;
    M.setAttribute('data-pet', p);
    var vs = M.querySelectorAll('.am-v');
    for (var i = 0; i < vs.length; i++) {
      var v = vs[i], on = v.getAttribute('data-v') === p;
      v.hidden = !on;
      if (on && animate) { v.classList.remove('is-in'); void v.offsetWidth; v.classList.add('is-in'); }
    }
    for (var k = 0; k < triggers.length; k++) {
      var t = triggers[k], o = isOpen && t.__pet === p;
      t.classList.toggle('is-open', o);
      t.setAttribute('aria-expanded', o ? 'true' : 'false');
    }
  }
  function clearT() { clearTimeout(tOpen); clearTimeout(tClose); clearTimeout(tSwitch); }
  function show(p) {
    if (!M) return;
    clearT();
    loadImgs(M);
    var first = !isOpen;
    if (first) {
      place(); isOpen = true; openY = W.scrollY;
      M.classList.add('is-open'); M.setAttribute('aria-hidden', 'false'); H.classList.add('am-open');
    }
    var changed = cur !== p; cur = p;
    setView(p, first || changed);
  }
  function hide() {
    clearT();
    if (!isOpen || !M) return;
    isOpen = false;
    for (var i = 0; i < triggers.length; i++) { try { if (triggers[i].matches(':hover')) triggers[i].__wait = 1; } catch (e) {} }
    M.classList.remove('is-open'); M.setAttribute('aria-hidden', 'true'); H.classList.remove('am-open');
    setView(cur || 'hund', false);
  }
  function later(ms) { clearTimeout(tClose); tClose = setTimeout(hide, ms || 300); }
  /* Sicherheitsdreieck: bewegt sich die Maus schräg nach unten (Richtung Panel), wird nicht sofort umgeschaltet */
  function headingDown() {
    if (pts.length < 2) return false;
    var a = pts[0], b = pts[pts.length - 1], dy = b[1] - a[1], dx = Math.abs(b[0] - a[0]);
    return dy > 2 && dy >= dx * 0.25;
  }
  function bindTrigger(a) {
    if (a.__am) return;
    a.__am = 1;
    a.setAttribute('aria-expanded', 'false');
    a.setAttribute('aria-controls', 'arfMega-' + a.__pet);
    a.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse' || !desk.matches) return;
      clearTimeout(tClose); loadImgs(M);
      var p = a.__pet;
      if (!isOpen) { a.__wait = 1; clearTimeout(tOpen); tOpen = setTimeout(function () { a.__wait = 0; show(p); }, 160); }
      else if (p !== cur) { clearTimeout(tSwitch); tSwitch = setTimeout(function () { show(p); }, headingDown() ? 320 : 70); }
    });
    /* Falls die Maus beim Laden schon auf dem Link steht */
    a.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse' || !desk.matches || isOpen || a.__wait) return;
      a.__wait = 1; clearTimeout(tClose); clearTimeout(tOpen); loadImgs(M);
      tOpen = setTimeout(function () { a.__wait = 0; show(a.__pet); }, 160);
    });
    a.addEventListener('pointerleave', function (e) {
      a.__wait = 0;
      if (e.pointerType !== 'mouse') return;
      clearTimeout(tOpen); clearTimeout(tSwitch);
      if (isOpen) later(300);
    });
    a.addEventListener('click', function (e) {
      if (!desk.matches) return;
      if (lastPointer !== 'mouse' && !(isOpen && cur === a.__pet)) { e.preventDefault(); show(a.__pet); }
    });
    a.addEventListener('keydown', function (e) {
      if (!desk.matches) return;
      if (e.key === 'ArrowDown' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault(); show(a.__pet);
        setTimeout(function () { var f = M.querySelector('.am-v:not([hidden]) .am-gh'); if (f) f.focus(); }, 40);
      } else if (e.key === 'Escape') { hide(); }
    });
  }
  function initDesktop(m) {
    M = m; PN = m.querySelector('.am-pn');
    if (m.parentNode !== D.body) D.body.appendChild(m);
    triggers = [];
    var links = D.querySelectorAll('.pets-nav .pets-nav-link[aria-haspopup]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i], s = (a.getAttribute('href') || '') + ' ' + a.textContent;
      a.__pet = /katz|cat/i.test(s) ? 'katze' : (/hund|dog/i.test(s) ? 'hund' : null);
      if (!a.__pet) continue;
      triggers.push(a); bindTrigger(a);
      var nav = a.closest('.pets-nav');
      if (nav && !nav.__am) { nav.__am = 1; nav.addEventListener('pointerenter', function () { loadImgs(M); }); }
    }
    PN.addEventListener('pointerenter', function () { clearTimeout(tClose); clearTimeout(tSwitch); });
    PN.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') later(300); });
    m.querySelector('.am-bd').addEventListener('click', hide);
    m.addEventListener('click', function (e) {
      var tab = e.target.closest('.am-tab');
      if (tab) { show(tab.getAttribute('data-go')); var on = M.querySelector('.am-v:not([hidden]) .am-tab.is-on'); if (on) on.focus(); return; }
      var tk = e.target.closest('.am-tk');
      if (tk) { copyCode(tk); }
    });
    m.addEventListener('focusout', function (e) {
      var r = e.relatedTarget;
      if (!r) return;
      if (M.contains(r) || (r.closest && r.closest('.pets-nav'))) return;
      hide();
    });
  }

  /* ================= Handy ================= */
  var nOpen = false, lastFocus = null, tx0 = null, ty0 = null;
  function setPet(p, anim) {
    N.setAttribute('data-pet', p);
    var bs = N.querySelectorAll('[data-mgo]');
    for (var i = 0; i < bs.length; i++) { var on = bs[i].getAttribute('data-mgo') === p; bs[i].classList.toggle('is-on', on); bs[i].setAttribute('aria-selected', on ? 'true' : 'false'); }
    var vs = N.querySelectorAll('.amn-pet');
    for (var k = 0; k < vs.length; k++) {
      var v = vs[k], o = v.getAttribute('data-v') === p;
      v.hidden = !o;
      if (o && anim) { v.classList.remove('is-in'); void v.offsetWidth; v.classList.add('is-in'); }
    }
  }
  function nShow() {
    if (!N || nOpen) return;
    if (isOpen) hide();
    loadImgs(N); nOpen = true; lastFocus = D.activeElement;
    N.classList.remove('is-sub');
    N.classList.add('is-open'); N.setAttribute('aria-hidden', 'false'); H.classList.add('amn-open');
    var x = N.querySelector('.amn-lv--root [data-x].amn-x');
    setTimeout(function () { if (x) x.focus({ preventScroll: true }); }, 60);
  }
  function nHide() {
    if (!N || !nOpen) return;
    nOpen = false;
    N.classList.remove('is-open'); N.setAttribute('aria-hidden', 'true'); H.classList.remove('amn-open');
    setTimeout(function () { if (!nOpen) { N.classList.remove('is-sub'); var s = N.querySelector('.amn-lv--sub'); if (s) s.innerHTML = ''; } }, 460);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  function back() { N.classList.remove('is-sub'); }
  function drill(row) {
    var name = row.getAttribute('data-name') || '', href = row.getAttribute('href'), cnt = row.getAttribute('data-count') || '';
    var subs = []; try { subs = JSON.parse(row.getAttribute('data-subs') || '[]'); } catch (e) {}
    var im = row.querySelector('img'), src = im ? (im.currentSrc || im.getAttribute('src') || im.getAttribute('data-src') || '') : '';
    var pet = (row.closest('.amn-pet') || N).getAttribute('data-v') === 'katze' ? 'Katze' : 'Hund';
    var hasCnt = +cnt > 0;
    var sub = N.querySelector('.amn-lv--sub');
    sub.innerHTML =
      '<div class="amn-top"><button type="button" class="amn-back" data-back aria-label="Zurück zu ' + pet + '">' + CHEV + '<span>' + pet + '</span></button>' +
      '<button type="button" class="amn-x" data-x aria-label="Menü schließen">' + XI + '</button></div>' +
      '<div class="amn-scroll"><div class="amn-hero"><span class="amn-ic amn-ic--xl"><img src="' + esc(src) + '" alt=""></span><span><span class="amn-hero-n">' + esc(name) + '</span>' +
      (hasCnt ? '<span class="amn-hero-c">' + cnt + ' Produkte</span>' : '') + '</span></div>' +
      '<nav class="amn-list" aria-label="' + esc(name) + '"><a class="amn-li amn-li--all" href="' + esc(href) + '">Alle ' + esc(name) + ' ansehen' + CHEV + '</a>' +
      subs.map(function (s) { return '<a class="amn-li" href="' + esc(s[1]) + '">' + esc(s[0]) + CHEV + '</a>'; }).join('') + '</nav>' +
      '</div>' +
      '<div class="amn-foot"><a class="amn-cta" href="' + esc(href) + '">' + (hasCnt ? 'Alle ' + cnt + ' Produkte ansehen' : 'Alle Produkte ansehen') + ARROW + '</a></div>';
    N.classList.add('is-sub');
    var b = sub.querySelector('[data-back]');
    setTimeout(function () { if (b) b.focus({ preventScroll: true }); }, 60);
  }
  function initMobile(n) {
    N = n;
    if (n.parentNode !== D.body) D.body.appendChild(n);
    setPet(petFromPath(), false);
    n.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-x]')) { e.preventDefault(); nHide(); return; }
      if (t.closest('[data-back]')) { e.preventDefault(); back(); return; }
      var g = t.closest('[data-mgo]');
      if (g) { setPet(g.getAttribute('data-mgo'), true); return; }
      var tk = t.closest('[data-code]');
      if (tk) { copyCode(tk); return; }
      var row = t.closest('.amn-row[data-subs]');
      if (row) { e.preventDefault(); drill(row); }
    });
    var sh = n.querySelector('.amn-sh');
    sh.addEventListener('touchstart', function (e) { var p = e.touches[0]; tx0 = p.clientX; ty0 = p.clientY; }, { passive: true });
    sh.addEventListener('touchend', function (e) {
      if (tx0 === null) return;
      var p = e.changedTouches[0], dx = p.clientX - tx0, dy = Math.abs(p.clientY - ty0); tx0 = null;
      if (dy > 60 || Math.abs(dx) < 70) return;
      if (dx < 0) nHide(); else if (N.classList.contains('is-sub')) back();
    }, { passive: true });
  }

  /* ================= Globale Ereignisse ================= */
  D.addEventListener('pointerdown', function (e) {
    lastPointer = e.pointerType || 'mouse';
    if (N && e.target.closest && e.target.closest('.pets-mobile-menu-btn, .pets-mobile-button, [data-pets-drawer-open]')) loadImgs(N);
  }, true);
  D.addEventListener('mousemove', function (e) { pts.push([e.clientX, e.clientY]); if (pts.length > 4) pts.shift(); }, { passive: true });
  W.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    /* Hamburger (Handy & Desktop) öffnet das neue Menü */
    if (N && t.closest('.pets-mobile-menu-btn, .pets-mobile-button, [data-pets-drawer-open]')) {
      e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      nShow(); return;
    }
    /* Desktop: „Kategorien“-Knopf (beim Scrollen) öffnet das Mega-Menü */
    if (desk.matches && M && t.closest('.arf-kat')) {
      e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      if (isOpen) hide(); else show(cur || petFromPath());
    }
  }, true);
  D.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (nOpen) { if (N.classList.contains('is-sub')) back(); else nHide(); return; }
    if (isOpen) {
      var had = M.contains(D.activeElement); var p = cur; hide();
      if (had) { for (var i = 0; i < triggers.length; i++) if (triggers[i].__pet === p) { triggers[i].focus(); break; } }
    }
  });
  W.addEventListener('scroll', function () {
    if (!isOpen) return;
    if (Math.abs(W.scrollY - openY) > 60) hide(); else place();
  }, { passive: true });
  W.addEventListener('resize', function () {
    if (isOpen) { if (!desk.matches) hide(); else place(); }
  });

  function unpaint(root) { if (!root) return; var l = root.querySelectorAll('.arf-btn'); for (var i = 0; i < l.length; i++) l[i].classList.remove('arf-btn'); }
  function init() {
    /* Theme-Editor: nach dem Neuladen der Sektion alte (in <body> verschobene) Kopien entfernen */
    ['arfMega', 'arfMenu'].forEach(function (id) {
      var l = D.querySelectorAll('[id="' + id + '"]');
      if (l.length < 2) return;
      for (var i = 0; i < l.length; i++) if (l[i].parentNode === D.body) l[i].remove();
    });
    var m = D.getElementById('arfMega'), n = D.getElementById('arfMenu');
    isOpen = false; nOpen = false; cur = null;
    H.classList.remove('am-open', 'amn-open');
    if (m) initDesktop(m);
    if (n) initMobile(n);
    setTimeout(function () { unpaint(M); unpaint(N); }, 1200);
    var idle = W.requestIdleCallback || function (f) { return setTimeout(f, 1); };
    setTimeout(function () { idle(function () { loadImgs(desk.matches ? M : N); }); }, 3500);
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init); else init();
  D.addEventListener('shopify:section:load', function () { setTimeout(init, 0); });
})();
